// extracted by mini-css-extract-plugin
export default {"bookingPill":"attribute-module___bookingPill___a0f3c95d"};